module.exports = __webpack_public_path__ + "static/images/partially-completed-stop.svg";